import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Conditions",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "earlyCharge",
        displayName: "%deposit",
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Charge first night",
      },
      {
        fieldName: "policies",
        displayName: "Cancellation policies",
      },
      {
        fieldName: "payments",
        displayName: "Payment methods",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Minimum charge",
      },
      {
        fieldName: "color",
        displayName: "Color",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "color",
        displayName: "Color",
      },
      {
        fieldName: "payments",
        displayName: "Payment methods",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "earlyCharge",
        displayName: "% Advance deposit",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Minimum charge",
      },
      {
        fieldName: "policies",
        displayName: "Cancellation policies",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Charge first night",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "htmlCancellation",
        displayName: "Cancellations / Prepayment",
      },
      {
        fieldName: "htmlCheckIn",
        displayName: "Check-in time",
      },
      {
        fieldName: "htmlCheckOut",
        displayName: "Check-out time",
      },
      {
        fieldName: "htmlChildren",
        displayName: "Children and extra beds",
      },
      {
        fieldName: "htmlPets",
        displayName: "Pets",
      },
      {
        fieldName: "htmlGroups",
        displayName: "Groups",
      },
      {
        fieldName: "htmlExtraInfo",
        displayName: "More information",
      },
    ],
  },
};
